import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, serverTimestamp as firebaseServerTimestamp } from 'firebase/firestore';

// Debug: Check if environment variables are loaded
console.log('Firebase Config Environment Variables:', {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY ? 'Present' : 'Missing',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ? 'Present' : 'Missing',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ? 'Present' : 'Missing',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ? 'Present' : 'Missing',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ? 'Present' : 'Missing',
    appId: process.env.REACT_APP_FIREBASE_APP_ID ? 'Present' : 'Missing'
});

const firebaseConfig = {
    apiKey: "AIzaSyCjr-r-GZN4flKZPmJhxIzc5yowmcFQTO4",
  authDomain: "realtimechatapp-57e81.firebaseapp.com",
  projectId: "realtimechatapp-57e81",
  storageBucket: "realtimechatapp-57e81.firebasestorage.app",
  messagingSenderId: "23725959347",
  appId: "1:23725959347:web:dcbf8f8a3cd583650e28c6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Auth and Firestore instances
export const auth = getAuth(app);
export const db = getFirestore(app);
export const serverTimestamp = firebaseServerTimestamp;

export default app;
